import {  Route, Routes } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import SignupPage from "./pages/signup";
import PaymentQrCode from "./pages/paymentQrcode";



function App() {
  return (
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/:slug" element={<LoginPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/payment" element={<PaymentQrCode />} />

      </Routes>
  );
}

export default App;
